$(document).ready(function()
{
	$(".faq-row").each(function()
	{
		$(this).click( { obj: this }, function( event )
		{
			toggleFaqs( event.data.obj );
		})
	});

	$.ajaxSetup({
	    headers: {
	        'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
	    }
	});
})

var captchaCallBack = function( response )
{
	$("#recaptcha-value").val( response )
}

var recaptcha1;
var recaptcha2;
var loadCaps = function()
{
	recaptcha1 = grecaptcha.render('signup-recaptcha',
	{
		'sitekey' : '6LdcWeMSAAAAAIeoBDSS_7p5zewlDG3Tx2PjpIOQ',
		'callback': captchaCallBack,
		'theme' : 'light'
	});

	recaptcha2 = grecaptcha.render('contact-recaptcha',
	{
		'sitekey' : '6LdcWeMSAAAAAIeoBDSS_7p5zewlDG3Tx2PjpIOQ',
		'callback': captchaCallBack,
		'theme' : 'light'
	});
};

var captchaCallBack = function( response )
{
	$("#recaptcha-value").val( response )
}

function toggleFaqs( obj )
{
	$(".faq-content").hide();
	$(obj).find('.faq-content').show();
}

function sendContact()
{
	// if( $("#env").val() == "production" )
	// {
	// 	clicky.log(this.href, 'contact-send-click');
	// }

	$("#contact-button").addClass('is-loading');

	$.ajax({
		type: "POST",
		url: "/contact",
		dataType: 'json',
		data:
		{
			name: $("#name").val(),
			email: $("#email").val(),
			message: $("#message").val(),
			recaptcha: $("#recaptcha-value").val()
		}
	}).done(function( msg )
	{
		$("#contact-modal .modal-card-body").html("");
		$("#contact-button").removeClass('is-loading');
		if( msg.success )
		{
			$("#contact-modal .modal-card-body").html("Thank you for contacting LOTOBuilder. Your message had been sent.");
		}
		else
		{
			$("#contact-modal .modal-card-body").html( msg.error );
		}
		openContactModal();
	});
}

function openContactModal()
{
	$("#contact-modal").addClass('is-active');
}

function closeContactModal()
{
	$("#contact-modal").removeClass('is-active');
}

function openLoginModal()
{
	$("#login-modal").addClass('is-active');
}

function closeLoginModal()
{
	$("#login-modal").removeClass('is-active');
}

function handleEnter()
{

}

function loginOrAsk()
{
	clickyLog('login-click');

	$.ajax({
		type: "GET",
		url: "/login/check",
		dataType: 'json',
	}).done(function( msg )
	{
		if( msg.success )
		{
			if( msg.authenticated )
			{
				// redirect
				window.location = "/procedures";
			}
			else
			{
				// Show login modal
				openLoginModal();
			}
		}
		else
		{
			alert('Error checking login. Please contant support.');
		}
	});
}

function login()
{
	$.ajax({
		type: "POST",
		url: "/login",
		dataType: 'json',
		data:
		{
			email: $("#login-email").val(),
			password: $("#login-password").val()
		}
	}).done(function( msg )
	{
		if( msg.success )
		{
			window.location = "/procedures";
		}
		else
		{
			$("#login-message").html(msg.error);
		}
	});
}

function clearLoginError()
{
	$("#login-message").html("");
}

function closeSignupModal()
{
	$("#signup-modal").removeClass("is-active");
}

function openSignupModal()
{
	// if( $("#env").val() == "production" )
	// {
	// 	clicky.log(this.href, 'signup-click');
	// 	clicky.goal( 'click-free-trial' );
	// }

	$("#signup-modal").addClass("is-active");
}

function signup()
{
	$("#signup-button").addClass('is-loading');
	$.ajax({
		type: "POST",
		url: "/signup",
		dataType: 'json',
		data:
		{
			first_name: $("#signup-first").val(),
			last_name: $("#signup-last").val(),
			organization_name: $("#signup-organization-name").val(),
			email: $("#signup-email").val(),
			phone: $("#signup-phone").val(),
			password: $("#signup-password").val(),
			retype_password: $("#signup-password-confirm").val(),
			'not_a_robot': $("#recaptcha-value").val()
		}
	}).done(function( msg )
	{
		$("#signup-button").removeClass('is-loading');
		if( msg.success )
		{
			$("#activation-email").val( $("#signup-email").val() );
			$("#signup-modal").removeClass('is-active');
			$("#activation-modal").addClass('is-active');
			$("#activation-code").focus();
			gtag_report_conversion();
			// clickyLog('example-procedure-download');
		}
		else
		{
			$("#signup-errors").html( msg.errors.join('<br />') )
		}

		$("#signup-button").removeClass('is-loading');
	});
}

function openActivationModal()
{
	$(".modal").removeClass('is-active');
	$("#activation-modal").addClass('is-active');
}

function closeActivationModal()
{
	$(".modal").removeClass('is-active');
}

function activateAccount()
{
	$("#activation-button").addClass('is-loading');
	$.ajax({
		type: "POST",
		url: "/activation",
		dataType: 'json',
		data:		{
			email: $("#activation-email").val(),
			code: $("#activation-code").val()
		}
	}).done(function( msg )
	{
		$("#activation-button").removeClass('is-loading');
		if( msg.success )
		{
			window.location = "/procedures";
		}
		else
		{
			$("#activation-help").html(msg.error);
		}
	});
}

function forgotPassword()
{
	openForgotPasswordModal();
	$("#forgot-password-button").addClass('is-loading');
	$.ajax({
		type: "POST",
		url: "/forgot_password",
		dataType: 'json',
		data:
		{
			email: $("#forgot_password_email").val()
		}
	}).done(function( msg )
	{
		if( msg.success )
		{
			$("#forgot-password-button").removeClass('is-loading');
			$("#forgot-password-button").hide();
			$("#forgot-password-form").hide();
			$("#password-reset-email-sent").show();
		}
		else
		{
			alert(msg.error);
		}

		$("#forgot-password-button").removeClass('is-loading');
	});
}

function openForgotPasswordModal()
{
	$(".modal").removeClass('is-active');
	$("#forgot-password-modal").addClass('is-active');
}

function closeForgotPasswordModal()
{
	$("#forgot-password-modal").removeClass('is-active');
}

function saveNewPassword()
{
	$("#reset-password-button").addClass('is-loading');
	$.ajax({
		type: "POST",
		url: "/password",
		dataType: 'json',
		data:
		{
			password: $("#password").val(),
			confirm_password: $("#confirm-password").val(),
			token: $("#token").val(),

		}
	}).done(function( msg )
	{
		$("#reset-password-button").removeClass('is-loading');
		if( msg.success )
		{
			window.location = '/procedures';
		}
		else
		{
			$("#reset-password-help").html( msg.error );
		}
	});
}